var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEditing)?_c('div',{staticClass:"editable-string editing-cell"},[_c('vs-input',{attrs:{"color":"#2D9CDB"},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1):_c('div',{staticClass:"editable-string"},[_vm._v("\n  "+_vm._s(_vm.string)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }